import { Col, Row } from "antd";
import React, { FC } from "react";
import classes from "./style/PageLayoutLogin.module.css";
import { Outlet } from "react-router-dom";
import { Logo } from "../../components/Logo/Logo";

export const PageLayoutLogin: FC = () => {
  return (
    <Row style={{ margin: "0" }}>
      <Col xs={0} sm={9} md={7} lg={8} xl={8}>
        <div className={classes.sideBar}></div>
      </Col>
      <Col xs={24} sm={15} md={17} lg={16} xl={16}>
        <Logo />
        <div className={classes.wrapperPageLogin}>
          <Outlet />
        </div>
      </Col>
    </Row>
  );
};
